import * as React from "react";
import { FC, useState } from "react";
import cx from "classnames";
import ProductsTable from "./ProductsTable";
import { Product } from "~/apps/pos/models";

type Props = {
  group: Product[];
  canManage: boolean;
  isCategoryEnabled: boolean; 
  onEdit: (row: Product) => void;
  onDelete: (row: Product) => void;
};

export const ProductGroupAccordion: FC<Props> = ({ group, canManage, isCategoryEnabled, onEdit, onDelete }) => {
  const [showProducts, setShowProducts] = useState(false);

  return (
    <div className="accordion">
      <div className="accordion-header" onClick={() => setShowProducts(!showProducts)}>
        <span className={cx("i", { "i-arw-r": !showProducts, "i-arw-b": showProducts })} />
        <span>{group[0].group?.name}</span>
      </div>
      {showProducts && (
        <div className="accordion-container">
          <ProductsTable
            data={group}
            canManage={canManage}
            isCategoryEnabled={isCategoryEnabled}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        </div>
      )}
    </div>
  );
};
